<template>
    <div id="dashboard-view">
        <table v-if="player" class="main-table">
            <tbody>
                <tr>
                    <th>Name</th>
                    <td><strong>{{player.name}}</strong></td>
                </tr>
                
                <tr>
                    <th class="clickable" @click="setSortBy('id')">ID</th>
                    <td>{{player.id}}</td>
                </tr>
                <tr>
                    <th>Level</th>
                    <td>{{player.level}}</td>
                </tr>
                <tr>
                    <th>Rank</th>
                    <td>{{player.rank}}</td>
                </tr>
                <tr>
                    <th>Age</th>
                    <td>{{player.age}}</td>
                </tr>
                <tr>
                <th>Friends</th>
                    <td>{{player.friends}}</td>
                </tr>
                <tr>
                <th>Enemies</th>
                    <td>{{player.enemies}}</td>
                </tr>
                <tr>
                <th>Subscriber</th>
                    <td>{{player.donator ? 'Yes' : 'No'}}</td>
                </tr>
                <tr>
                    <th>Role</th>
                    <td>{{player.role}}</td>
                </tr>
                <tr style="background-color: black;">
                    <th class="clickable" @click="setSortBy('interactions')"> Interactions</th>
                    <td>Total: {{getPlayerInteractionCount(player)}}</td>
                </tr>
                <template v-for="item_key in Object.keys(interactions)" :key="`interaction-header-${player.id}-${item_key}`">
                    <tr>
                        <th @click="setSortBy(item_key)"  class="clickable">
                            As {{titleCase(item_key.replaceAll('_', ' '))}}
                        </th>
                        <td>
                            {{interactions[item_key].logs.length}}
                        </td>
                    </tr>
                </template>
                <tr>
                    <td colspan="9" style="height: 10px; padding: 0; background-color: #111;"> </td>
                </tr>
            </tbody>
        </table>
        <table class="main-table gaps">
           
            <thead>
                <th>Timestamp</th>
                <th>Action</th>
                <th>Category</th>
                <th>Details</th>
            </thead>
            <tbody>
                <template  v-for="log in logs" :key="'log' + log.id">
                    <tr class="clear-gaps">
                        <td :title="log.timestamp">{{log.formatted_date}}</td>
                        <td>{{log.title}}</td>
                        <td>{{log.category}}</td>
                        <td class="sub-table-wrapper">
                            <table class="sub-table">
                                <thead>
                                    <th v-for="item_key in Object.keys(log.data).filter(key => !key.includes('_formatted'))" :key="`data-header-${log.id}-${item_key}`">
                                        {{titleCase(item_key.replaceAll('_', ' '))}}
                                    </th>
                                </thead>
                                <tbody>
                                    <tr>
                                        <template v-for="item_key in Object.keys(log.data).filter(key => !key.includes('_formatted'))" :key="`data-column-${log.id}-${item_key}`">
                                            <td v-if="['log', 'reason'].includes(item_key)" v-html="log.data[item_key]" class="log-link">
                                            </td>
                                            <td v-else v-html="log.data[`${item_key}_formatted`]">
                                            </td>
                                        </template>
                                    </tr>
                                </tbody>

                            </table>
                            <!-- <td v-if="log.data?.log" class="log-link" v-html="log.data.log">   </td>
                            <td> TEST </td> -->
                        </td>
                    </tr>
                    <!-- <tr>
                        <td colspan="4" style="height: 5px; padding: 0; background-color: #111;"> </td>
                    </tr> -->
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
import axios from 'axios';
import {INTERACTION_FIELDS} from '@/constants/players.js';
import {toRaw} from 'vue';

// @ is an alias to /src

const PLAYER_DATA_FIELD_NAMES = INTERACTION_FIELDS ;//['player', 'user', 'buster', 'attacker', 'author', 'defender', 'sender', 'seller', 'buyer', 'bailer', 'planner', 'initiator', 'assister', 'reviver', 'recipient', 'rater' ];

const sortByInteraction = (interaction) => (a, b) => {
    if ( a.interactions[interaction].length > b.interactions[interaction].length ) return 1;
    else if ( a.interactions[interaction].length < b.interactions[interaction].length ) return -1;
    else return 0; 
}

export default {
    name: 'Player Info',
    data() {
        return {
            sort_by: 'id',
            sort_by_dir: 'asc'
        }
    },
    components: {
        
    },
    methods: {
       
        fetchAllPlayers() {
            this.$store.dispatch('fetchMissingPlayers');
        },

        calculatePlayerStats() {
            this.$store.dispatch('calculatePlayerStats');
        },
        
        async fetchBrokenPlayers() {
            let player_ids = await database.players.orderBy('id').toArray();
            player_ids=player_ids.filter(player => {
                return player.error
            }).map(player => player.id);

            let players_to_delete = player_ids.filter(id => id < 0);
            for (let id of players_to_delete) {
                database.players.delete(id);
            }

            let players_to_fetch = player_ids.filter(id => id > 0);

            this.$store.dispatch('fetchPlayers', players_to_fetch);
        },

        renderData(data) {
            if (isNaN(data) || !data && data !== 0) return data;
            else if (Math.ceil(data) == data) return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            else return parseFloat(data).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        getPlayerInteractionCount(player) {
            let total = 0;
            PLAYER_DATA_FIELD_NAMES.forEach(field => {
                total += this.interactions[field]?.logs.length || 0
            });
            return total;
        },
        setSortBy(field) {
            if (this.sort_by === field) {
                this.sort_by_dir = this.sort_by_dir === 'asc' ? 'desc' : 'asc';
            } else this.sort_by = field;
        }
    },
    
    computed: {
        auth_key() {
            return this.$store.state.auth.key;
        },

        player() {
            let tplayer = this.$store.state.players[this.$route.params.player_id];
            return tplayer;
        },

        logs() {
            return this.$store.getters.logs;
        },

        database() {
            return this.$store.getters.database;
        },

        interactions() {
            return this.player?.interactions.reduce((mapped, eventtype) => {
                mapped[eventtype.name] = eventtype;
                return mapped;
            }, {});
        }
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$store.dispatch('getPlayers');
            vm.$store.dispatch('getLogs', {
                ...toRaw(vm.$store.state.filters),
                category: null,
                player_id: vm.player?.id || null
            });
        })


    }
}
</script>
<style lang="scss">
    #dashboard-view {

    }

    #key-input-bar {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

</style>